import { Box, Divider, Flex, Text } from '@byecode/ui'
import React from 'react'
import styled from 'styled-components'

import { useFillPickerContext } from '../Provider'

const ColorItem = styled.button`
    all: unset;
    appearance: none;
    box-sizing: border-box;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    cursor: pointer;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: inherit;
        transition: transform 0.15s ease;
    }

    &:hover::before {
        transform: scale(1.15);
    }

    &:active::before {
        transform: scale(0.95);
    }
`

const ColorList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

interface RecentColorsProps {
    onSelect: (color: string) => void
}

/**
 * 最近使用的颜色列表组件
 */
export const RecentColors = ({ onSelect }: RecentColorsProps) => {
    const { recentColors } = useFillPickerContext()

    if (recentColors.length === 0) {
        return null
    }

    return (
        <Box py={8}>
            <Divider mt={8} mb={16} />
            <Flex alignItems="center" justifyContent="space-between" styles={{ root: { height: 36 } }}>
                <Text size={14} lineHeight="22px">
                    最近使用
                </Text>
            </Flex>

            <ColorList>
                {recentColors.map((color, index) => (
                    <ColorItem key={`${color}-${index}`} style={{ background: color }} onClick={() => onSelect(color)} title={color} />
                ))}
            </ColorList>
        </Box>
    )
}
